module.exports = __webpack_public_path__ + "static/media/hideAdsYear.28bc92db.svg";